export const accordionCustomStyles = {
  marginBottom: '16px',
  '.MuiAccordionSummary-content.Mui-expanded': {
    marginBottom: '8px',
  },
};

export const tableCustomStyles = {
  '.table-body .table-cell': {
    verticalAlign: 'top',
  },
};

// Transient amber tint on the deep-linked row (`&item=` — DEV-5146). Keyed by the
// SimpleTable row's `data-row-id`; the id is sanitized because it lands inside a CSS
// attribute selector.
export const getHighlightedRowStyles = itemId => ({
  [`.table-body [data-row-id="${String(itemId).replace(/[^\w-]/g, '')}"] .table-cell`]: {
    backgroundColor: ({ palette }) => palette.warning.extraSoft,
    transition: 'background-color 0.4s ease',
  },
});

export const fieldCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const contextTextStyles = {
  color: ({ palette }) => palette.text.secondary,
};
